/**
 * Urine Test Formula
 * Uses the same comparison semantics as admin and shares the same field set
 * as the urine page/dashboard helper.
 */

import { compareValues } from "./labComparison";
import { URINE_FORMULA_RULES } from "../utils/urineDataUtils";

const FIELD_LABEL = {
  color: "สีของปัสสาวะ",
  clarity: "ความใส (Clarity)",
  appearance: "ลักษณะปัสสาวะ (Appearance)",
  ph: "ค่า pH",
  specificGravity: "ความถ่วงจำเพาะ",
  protein: "โปรตีน (Protein)",
  glucose: "น้ำตาล (Glucose)",
  ketones: "คีโตน (Ketone)",
  blood: "เลือด (Blood)",
  leukocytes: "Leukocyte",
  nitrite: "Nitrite",
  bilirubin: "Bilirubin",
  urobilinogen: "Urobilinogen",
  redBloodCells: "เซลล์เม็ดเลือดแดง (RBC)",
  whiteBloodCells: "เซลล์เม็ดเลือดขาว (WBC)",
  bacteria: "แบคทีเรีย",
  epithelialCells: "เซลล์เยื่อผิว (Epithelial Cells)",
  nonsquamousEpithelialCell: "Non-squamous epithelial cell",
  renalTubularEpithelialCell: "Renal tubular epithelial cell",
  rbcCast: "RBC cast",
  hyalineCast: "Hyaline cast",
  granularCast: "Granular cast",
  cellularCast: "Cellular cast",
  waxyCast: "Waxy cast",
  crystal: "Crystal",
  calciumOxalateCrystal: "Calcium oxalate crystal",
  calciumCarbonateCrystal: "Calcium Carbonate crystal",
  uricAcidCrystal: "Uric acid crystal",
  triplePhosphateCrystal: "Triple phosphate crystal",
  cystineCrystal: "Cystine crystal",
  calciumPhosphateCrystal: "Calcium phosphate crystal",
  yeast: "Yeast",
  mucusThread: "Mucus",
  others: "Others",
};

const STATUS_FIELDS = [
  "glucose",
  "protein",
  "redBloodCells",
  "whiteBloodCells",
];

const UrineTestFormula = (urineData) => {
  if (!urineData || typeof urineData !== "object") {
    return {
      status: "ไม่มีข้อมูล",
      color: "gray",
      description: "ไม่พบข้อมูลการตรวจปัสสาวะ",
      abnormalFindings: [],
    };
  }

  const abnormalFindings = [];

  STATUS_FIELDS.forEach((field) => {
    const normalRange = URINE_FORMULA_RULES[field];
    const value = urineData[field];
    const comparison = compareValues(normalRange, value, FIELD_LABEL[field] || field);

    if (comparison.status !== "normal" && comparison.label !== "-") {
      abnormalFindings.push(FIELD_LABEL[field] || field);
    }
  });

  if (abnormalFindings.length === 0) {
    return {
      status: "ปกติ",
      color: "green",
      description: "ผลการตรวจปัสสาวะอยู่ในเกณฑ์ปกติ",
      abnormalFindings: [],
    };
  }

  return {
    status: "ผิดปกติ",
    color: "red",
    description: `พบค่าผิดปกติ: ${abnormalFindings.join(", ")}`,
    abnormalFindings,
  };
};

export default UrineTestFormula;
